<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		widthLabel: string;
		width: number;
		labelClass?: string;
	}

	let { widthLabel, width, labelClass = 'bg-[#F7F2E9]' }: Props = $props();
</script>

<div class="mt-4 h-4 border-x border-brown-1 transition-all" style="width: {width}%">
	<div class="flex h-full items-center">
		<div class="flex h-[1px] w-full items-center justify-center bg-brown-1">
			<div class={['select-none px-2 text-brown-1', labelClass]}>{widthLabel}”</div>
		</div>
	</div>
</div>
